import defaultClient from '@src/api/clients/default';

// GET api/dashboard/forecast/?client_id&period -> scenarios + segments + recommendations
export function fetchForecast(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/forecast/',
    payload,
  });
}

// POST api/dashboard/forecast/what-if/ {client_id, period, overrides:[{budget_id, budget}]}
export function fetchForecastWhatIf(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/forecast/what-if/',
    method: 'POST',
    payload,
  });
}

// POST api/dashboard/forecast/refresh/ (staff) -> persist a rebuild
export function refreshForecast(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/forecast/refresh/',
    method: 'POST',
    payload,
  });
}

// GET api/dashboard/forecast/month-to-date/?client_id -> stored forecast vs MTD actuals
export function fetchForecastMonthToDate(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/forecast/month-to-date/',
    payload,
  });
}

export default {
  fetchForecast,
  fetchForecastWhatIf,
  refreshForecast,
  fetchForecastMonthToDate,
};
